import { useState, useEffect } from 'react'

const windowAvailable = typeof window === 'object'

const getWindowSize = () => ({
  width: windowAvailable ? window.innerWidth : undefined,
  height: windowAvailable ? window.innerHeight : undefined,
})

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(getWindowSize)

  useEffect(() => {
    if (!windowAvailable) return

    const handleResize = () => setWindowSize(getWindowSize())

    window.addEventListener('resize', handleResize) // on mount
    return () => window.removeEventListener('resize', handleResize) // on unmount
  }, [])

  return windowSize
}

export default useWindowSize
